import { render, staticRenderFns } from "./starchaser-details.vue?vue&type=template&id=0251e740&scoped=true&"
import script from "./starchaser-details.vue?vue&type=script&lang=js&"
export * from "./starchaser-details.vue?vue&type=script&lang=js&"
import style0 from "./starchaser-details.vue?vue&type=style&index=0&id=0251e740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251e740",
  null
  
)

export default component.exports